import api from '@/services/api';

const ENDPOINT_BASE = 'cotizacion';

const resultado_produccion_service = {
  async obtenerResultados(codigoCotizacion) {
    const url = `/${ENDPOINT_BASE}/${codigoCotizacion}/resultado-produccion`;

    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('[SERVICE] ❌ Error en obtenerResultados:', error);
      throw error;
    }
  },

  async obtenerResultadoPorCantidad(codigoCotizacion, codigoCantidad) {
    const url = `/${ENDPOINT_BASE}/${codigoCotizacion}/resultado-produccion/${codigoCantidad}`;

    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('[SERVICE] ❌ Error en obtenerResultadoPorCantidad:', error);
      throw error;
    }
  },
};

export default resultado_produccion_service;
